<div class="notification-empty" *ngIf="notifications.length === 0">
  <i class="pi pi-bell notification-empty__icon" aria-hidden="true"></i>
  <p class="notification-empty__title" translate>label_no_notification_list</p>
</div>

<div class="scroll-container" *ngIf="notifications.length > 0">
  <div class="notification-card" *ngFor="let notification of notifications">
    <div class="notification-time grid">
      <div class="col-6 date">
        {{ notification.createdAt | dateformat }}
      </div>
      <div class="col-6 ago">
        {{ notification.createdAt | ago }}
      </div>
      <div class="col-12 message">
        {{ notification.message }}
      </div>
    </div>
  </div>

  <div class="notification-load-more" *ngIf="notifications.length > 0">
    <button pButton appRipple class="assign-btn load-more-btn" type="button" [label]="labelLoadMore"
      (click)="onLoadMore()"></button>
  </div>
</div>
